videojs.addLanguage('th', {
  "Audio Player": "โปรแกรมเล่นเสียง",
  "Video Player": "โปรแกรมเล่นวิดีโอ",
  "Play": "เล่น",
  "Pause": "หยุดชั่วคราว",
  "Replay": "เล่นซ้ำ",
  "Current Time": "เวลาปัจจุบัน",
  "Duration": "ระยะเวลา",
  "Remaining Time": "เวลาที่เหลือ",
  "Stream Type": "ประเภทของสตรีม",
  "LIVE": "ถ่ายทอดสด",
  "Seek to live, currently behind live": "หาโอกาสที่จะถ่ายทอดสด กำลังอยู่เบื้องหลังการถ่ายทอดสดในขณะนี้",
  "Seek to live, currently playing live": "หาโอกาสที่จะถ่ายทอดสด กำลังเล่นแบบสดในขณะนี้",
  "Loaded": "โหลดแล้ว",
  "Progress": "ความคืบหน้า",
  "Progress Bar": "แถบแสดงความคืบหน้า",
  "progress bar timing: currentTime={1} duration={2}": "{1} ของ {2}",
  "Fullscreen": "แบบเต็มหน้าจอ",
  "Non-Fullscreen": "ไม่ใช่แบบเต็มหน้าจอ",
  "Mute": "ปิดเสียง",
  "Unmute": "ยกเลิกการปิดเสียง",
  "Playback Rate": "อัตราการเล่น",
  "Subtitles": "คำบรรยาย",
  "subtitles off": "ปิดคำบรรยาย",
  "Captions": "คำอธิบายภาพ",
  "captions off": "ปิดคำอธิบายภาพ",
  "Chapters": "บท",
  "Descriptions": "คำอธิบาย",
  "descriptions off": "ปิดคำอธิบาย",
  "Audio Track": "แทร็กเสียง",
  "Volume Level": "ระดับเสียง",
  "You aborted the media playback": "คุณยกเลิกการเล่นสื่อแล้ว",
  "A network error caused the media download to fail part-way.": "ข้อผิดพลาดของเครือข่ายทำให้การดาวน์โหลดสื่อไม่สำเร็จเป็นบางส่วน",
  "The media could not be loaded, either because the server or network failed or because the format is not supported.": "ไม่สามารถโหลดสื่อได้ โดยอาจเป็นเพราะเซิร์ฟเวอร์หรือเครือข่ายล้มเหลว หรือเพราะรูปแบบไม่ได้รับการรองรับ",
  "The media playback was aborted due to a corruption problem or because the media used features your browser did not support.": "การเล่นสื่อถูกยกเลิกเนื่องจากปัญหาเกี่ยวกับความเสียหาย หรือเนื่องจากสื่อใช้ฟีเจอร์ที่เบราว์เซอร์ของคุณไม่รองรับ",
  "No compatible source was found for this media.": "ไม่พบแหล่งที่เข้ากันได้สำหรับสื่อนี้",
  "The media is encrypted and we do not have the keys to decrypt it.": "สื่อถูกเข้ารหัสลับแล้ว และเราไม่มีคีย์ที่จะถอดรหัสลับดังกล่าว",
  "Play Video": "เล่นวิดีโอ",
  "Close": "ปิด",
  "Close Modal Dialog": "ปิดกล่องโต้ตอบโมดอล",
  "Modal Window": "หน้าต่างโมดอล",
  "This is a modal window": "รายการนี้เป็นหน้าต่างโมดอล",
  "This modal can be closed by pressing the Escape key or activating the close button.": "คุณสามารถปิดโมดอลนี้โดยกดปุ่ม Escape หรือเปิดใช้งานปุ่มปิด",
  ", opens captions settings dialog": ", เปิดกล่องโต้ตอบการตั้งค่าคำอธิบายภาพ",
  ", opens subtitles settings dialog": ", เปิดกล่องโต้ตอบการตั้งค่าคำบรรยาย",
  ", opens descriptions settings dialog": ", เปิดกล่องโต้ตอบการตั้งค่าคำอธิบาย",
  ", selected": ", เลือกแล้ว",
  "captions settings": "การตั้งค่าคำอธิบายภาพ",
  "subtitles settings": "การตั้งค่าคำบรรยาย",
  "descriptions settings": "การตั้งค่าคำอธิบาย",
  "Text": "ข้อความ",
  "White": "สีขาว",
  "Black": "สีดำ",
  "Red": "สีแดง",
  "Green": "สีเขียว",
  "Blue": "สีน้ำเงิน",
  "Yellow": "สีเหลือง",
  "Magenta": "สีม่วงแดง",
  "Cyan": "สีน้ำเงินอมเขียว",
  "Background": "พื้นหลัง",
  "Window": "หน้าต่าง",
  "Transparent": "โปร่งใส",
  "Semi-Transparent": "กึ่งโปร่งใส",
  "Opaque": "ทึบ",
  "Font Size": "ขนาดแบบอักษร",
  "Text Edge Style": "ลักษณะขอบข้อความ",
  "None": "ไม่มี",
  "Raised": "ยกขึ้น",
  "Depressed": "ปล่อยออก",
  "Uniform": "รูปแบบ",
  "Dropshadow": "เพิ่มเงา",
  "Font Family": "ตระกูลแบบอักษร",
  "Proportional Sans-Serif": "Sans-Serif ตามสัดส่วน",
  "Monospace Sans-Serif": "Sans-Serif ช่องว่างเดี่ยว",
  "Proportional Serif": "Serif ตามสัดส่วน",
  "Monospace Serif": "Serif ช่องว่างเดี่ยว",
  "Casual": "ไม่เป็นทางการ",
  "Script": "สคริปต์",
  "Small Caps": "ตัวพิมพ์ใหญ่ขนาดเล็ก",
  "Reset": "รีเซ็ต",
  "restore all settings to the default values": "คืนค่าการตั้งค่าท้้งหมดให้เป็นค่าเริ่มต้น",
  "Done": "เสร็จสิ้น",
  "Caption Settings Dialog": "กล่องโต้ตอบการตั้งค่าคำอธิบายภาพ",
  "Beginning of dialog window. Escape will cancel and close the window.": "การเริ่มต้นหน้าต่างกล่องโต้ตอบ Escape จะยกเลิกและปิดหน้าต่าง",
  "End of dialog window.": "สิ้นสุดหน้าต่างกล่องโต้ตอบ",
  "{1} is loading.": "กำลังโหลด {1}",
  "Exit Picture-in-Picture": "ออกจากการเล่นภาพควบคู่",
  "Picture-in-Picture": "การเล่นภาพควบคู่"
});